import React, { Component } from 'react'
import { checkTextTranslation } from '../../utils/useful'

class RangeNumberInput extends Component {

    state = {}

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        let maxValue = this.props.header.information?.maxValue
        if (maxValue != null) {
            if (Number(value) > Number(maxValue)) {
                return
            }
        }
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value != '' ? Number(value) : null, this.props.extra)
        }
    }

    handleInputValueButton(key) {
        let maxValue = this.props.header.information?.maxValue
        if (key == 'plus') {
            let value = Number(this.props.data) + 1
            if (maxValue != null) {
                if (Number(value) > Number(maxValue)) {
                    return
                }
            }
            if (value !== null) {
                this.props.changeValue(this.props.header.key, value != '' ? Number(value) : null, this.props.extra)
            }
        }
        if (key == 'minus') {
            let value = Number(this.props.data) - 1
            if (Number(value) < 1) {
                return
            }
            else {
                this.props.changeValue(this.props.header.key, value != '' ? Number(value) : null, this.props.extra)
            }
        }
    }


    render() {
        return (
            <div className="flexcc w-100 h-100 br-6" style={{ border: '1px solid #e2e2e2' }}>
                <button className='h-100 p-1 flexcc' style={{ borderRight: '1px solid #e2e2e2' }} onClick={() => this.handleInputValueButton('minus')}>
                    <p>-</p>
                </button>
                <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.props.data != null ? this.props.data : this.props.changeValue(this.props.header.key, Number('1'), this.props.extra)} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} className="transpanet-input" />
                <button className='h-100 p-1 flexcc' style={{ borderLeft: '1px solid #e2e2e2' }} onClick={() => this.handleInputValueButton('plus')}>
                    <p>+</p>
                </button>
            </div>
        )
    }
}

export default RangeNumberInput;